/**
 * Full-page dashboard skeleton shown while the landing org is resolved.
 * Uses DashboardHomeSkeleton (V2 single-column layout) to match the
 * actual dashboard content and prevent layout shift (CLS).
 */

import DashboardLayout from '@/components/DashboardLayout';

import { DashboardHomeSkeleton } from './components/DashboardHomeSkeleton';

/**
 * Full-page dashboard skeleton with navigation.
 * Used by HomeRedirect as a standalone loading state (not inside an existing
 * DashboardLayout). Uses skipGuard because it renders before an org is known —
 * a nested TeamGuard would have nothing to guard yet.
 */
export default function DashboardSkeleton() {
  return (
    <DashboardLayout skipGuard>
      <DashboardHomeSkeleton />
    </DashboardLayout>
  );
}
